import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { ArrowRight } from 'lucide-react';
export function ContrastSection() {
  const contrasts = [{
    before: 'Control',
    after: 'Calma'
  }, {
    before: 'Estrés',
    after: 'Claridad'
  }, {
    before: 'Tensión',
    after: 'Presencia'
  }, {
    before: 'Cansancio mental',
    after: 'Confianza'
  }];
  return <section className="py-24 bg-brown text-cream relative overflow-hidden" data-id="element-30">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-31">
        <FadeIn data-id="element-32">
          <div className="text-center mb-16" data-id="element-33">
            <h2 className="text-3xl md:text-4xl font-serif text-gold mb-4" data-id="element-34">
              El cambio es inevitable
            </h2>
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 gap-6 max-w-3xl mx-auto" data-id="element-35">
          {contrasts.map((item, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-36">
              <div className="flex flex-col sm:flex-row items-center justify-between bg-brown-dark/50 rounded-2xl p-6 border border-gold/10" data-id="element-37">
                <div className="w-full sm:w-2/5 text-center sm:text-right" data-id="element-38">
                  <span className="text-xl md:text-2xl font-serif text-cream/40 line-through decoration-rose/30" data-id="element-39">
                    {item.before}
                  </span>
                </div>

                <div className="my-4 sm:my-0 w-full sm:w-1/5 flex justify-center" data-id="element-40">
                  <ArrowRight className="w-6 h-6 text-gold opacity-50" data-id="element-41" />
                </div>

                <div className="w-full sm:w-2/5 text-center sm:text-left" data-id="element-42">
                  <span className="text-2xl md:text-3xl font-serif text-gold font-bold" data-id="element-43">
                    {item.after}
                  </span>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}